import type { SVGProps } from "react";
import * as React from "react";

const SvgCornerDownRight = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      d="M15.707 9.293a1 1 0 1 0-1.414 1.414zM20 15l.707.707a1 1 0 0 0 0-1.414zm-5.707 4.293a1 1 0 0 0 1.414 1.414zM5 4a1 1 0 0 0-2 0zm-1 7H3zm4 4v1zm6.293-4.293 5 5 1.414-1.414-5-5zm5 3.586-5 5 1.414 1.414 5-5zM3 4v7h2V4zm0 7a5 5 0 0 0 1.464 3.536L5.88 13.12A3 3 0 0 1 5 11zm1.464 3.536A5 5 0 0 0 8 16v-2a3 3 0 0 1-2.121-.879zM8 16h12v-2H8z"
    />
  </svg>
);
export default SvgCornerDownRight;
